import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icon_rio.svg")